import { api } from "./axios";
import {
  BusinessSnapshot,
  CresoEvent,
  News,
  EventCreate,
  Watchlist,
  watchlistUpdate,
} from "../types/home";

export function getBusinessSnapshot(): Promise<BusinessSnapshot> {
  return api.get("distributor/business-snapshot/");
}

export function getEvents(payload: {
  date?: string;
  clientId?: number;
}): Promise<CresoEvent[]> {
  return api.get("events/", {
    params: { date: payload.date, client_id: payload.clientId },
  });
}

export function createEvent(data: EventCreate): Promise<CresoEvent> {
  return api.post("events/", data);
}

export function updateEvent(
  data: Partial<EventCreate> & { id: number; is_deprecated?: boolean }
): Promise<CresoEvent> {
  return api.patch(`events/${data.id}/`, data);
}

export function deleteEvent(id: number): Promise<void> {
  return api.delete(`events/${id}/`);
}

export function getPendingEvents(clientId?: number): Promise<CresoEvent[]> {
  return api.get(`events/pending/`, { params: { client_id: clientId } });
}

export function getNews(): Promise<News[]> {
  return api.get("news/");
}

export function getWatchlist(): Promise<Watchlist> {
  return api.get("watchlists/");
}

export function addFundToWatchlist(data: watchlistUpdate): Promise<Watchlist> {
  return api.post("watchlists/add_funds/", data);
}

export function removeFundFromWatchlist(
  data: watchlistUpdate
): Promise<Watchlist> {
  return api.post("watchlists/remove_funds/", data);
}

interface Index {
  index_symbol: string;
  last: number;
  variation: number;
  percent_change: number;
}

export function getIndices(): Promise<Index[]> {
  return api.get("indices/");
}
